import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import Header from '../common/Header';
import Layout from '../common/Layout';
import Footer from '../common/Footer';

const StyledAnonymousLayout = styled(Layout)`
    .bg-transparent {
        background-color: transparent !important;
    }
`;
interface AnonymousLayoutProps {
    className?: string;
    isLoginScreen?: boolean;
    children?: React.ReactNode;
    [props: string]: any;
}

const AnonymousLayout: React.FC<AnonymousLayoutProps> = (props) => {
    const { className = '', children } = props;
    return (
        <StyledAnonymousLayout className={cx('login-bg', className)}>
            <Header {...props} className={`bg-transparent ${className}`} />
            <main className="w-full h-full">
                <div className="w-full h-full  overflow-x-hidden overflow-y-auto">{children}</div>
            </main>
            <Footer />
        </StyledAnonymousLayout>
    );
};

export default AnonymousLayout;
